module.exports = __webpack_public_path__ + "media/images/PGM-c69d0949b730d2027165eb19a6823ea6.svg";